import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import { ProtectedRoute } from '../auth';
import Signup from '../pages/Signup';
import Navbar from '../components/Navbar';
import Settings from '../pages/Settings';
import { useLocation } from 'react-router-dom';
import Login from '../pages/Login';
import ShowAsset from '../pages/Asset';
import NotFound from '../pages/Errors/404';
import { IsApprovedRoute } from '../auth/IsApprovedRoute';
import Waiting from '../pages/Waiting';
import AssetRegister from '../pages/AssetRegister';
import RegisterAssetSuccess from '../pages/RegisterAssetSuccess';

function RouteList() {
  const location = useLocation();

  const currentPath = location.pathname;

  return (
    <>
      {currentPath !== '/signup' &&
        currentPath !== '/registerasset' &&
        currentPath !== '/waiting' &&
        currentPath !== '/registerasset-success' &&
        currentPath !== '/login' && <Navbar />}
      <Routes>
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/registerasset" element={<AssetRegister />} />
        <Route
          path="/registerasset-success"
          element={<RegisterAssetSuccess />}
        />
        <Route path="/waiting" element={<Waiting />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              component={() => (
                <IsApprovedRoute>
                  <Home />
                </IsApprovedRoute>
              )}
            />
          }
        />

        <Route
          path="/asset/:id"
          element={
            <ProtectedRoute
              component={() => (
                <IsApprovedRoute>
                  <ShowAsset />
                </IsApprovedRoute>
              )}
            />
          }
        />

        <Route
          path="/settings"
          element={<ProtectedRoute component={() => <Settings />} />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default RouteList;
